<div class="icon-container"
     [ngStyle]="styleForContainer()">
  <ng-container *ngIf="isEmoji()">
    <div>{{textOrEmoji()}}</div>
  </ng-container>
  <ng-container *ngIf="!isEmoji()">
    <div>{{textOrEmoji()}}</div>
  </ng-container>
</div>